import Vue from "vue";
import firebase from "firebase";
import firebaseApp from "@/main";
import { v4 as uuidv4 } from "uuid";
import Vuex, { GetterTree, MutationTree, ActionTree } from "vuex";

// Interfaces
import {
  WorkoutTemplateSubmit,
  ChangeWorkoutTemplateOrder,
} from "@/interfaces/workoutTemplate.interface";
import { getNowInUnix } from "@/interfaces/time.interface";
import { userData, userWorkoutTemplate } from "@/interfaces/user.interface";

Vue.use(Vuex);

class State {
  workoutTemplates: userWorkoutTemplate[] = [];
}

const getters = <GetterTree<State, any>>{
  getUserTemplates(state): userWorkoutTemplate[] {
    return state.workoutTemplates;
  },
  getUserTemplatesByDate(state): userWorkoutTemplate[] {
    const temp: userWorkoutTemplate[] = state.workoutTemplates;
    return temp.sort((a, b) => b.dateCreated - a.dateCreated);
  },
};

const mutations = <MutationTree<State>>{
  addWorkoutTemplate(state, newTemplate: userWorkoutTemplate) {
    state.workoutTemplates.unshift(newTemplate);
  },
  updateWorkoutTemplate(state, updatedTemplate: userWorkoutTemplate) {
    state.workoutTemplates.forEach((template) => {
      if (template.id === updatedTemplate.id) {
        template = updatedTemplate;
      }
    });
  },
  updateUsersTemplates(
    state,
    newTemplates: { [id: string]: userWorkoutTemplate }
  ) {
    for (const id in newTemplates) {
      state.workoutTemplates.push(newTemplates[id]);
    }
  },
  deleteTemplate(state, templateIdToDelete: string) {
    let idx = -1;
    state.workoutTemplates.forEach((template, templateIdx) => {
      if (template.id === templateIdToDelete) idx = templateIdx;
    });
    if (idx !== -1) state.workoutTemplates.splice(idx, 1);
  },
};

const actions = <ActionTree<State, any>>{
  async createWorkoutTemplate(
    { rootGetters, getters, commit },
    payload: WorkoutTemplateSubmit
  ) {
    const myUID: string | null = rootGetters["userStore/getUserUID"];
    if (!myUID) return Promise.reject("NOT SIGNED IN");
    let suc = true;

    const userWorkoutTemplate: userWorkoutTemplate = {
      ...payload.workoutTemplateData,
      timesDone: 0,
      templateOrderIdx: getters.getUserTemplates.length,
      dateCreated: getNowInUnix(),
      id: uuidv4(),
      datesDone: [],
    };

    if (payload.id) userWorkoutTemplate.id = payload.id;

    if (rootGetters["userStore/isUserSignedIn"]) {
      await firebaseApp
        .firestore()
        .collection("users")
        .doc(rootGetters["userStore/getUserUID"])
        .set(
          {
            workoutTemplates: {
              [userWorkoutTemplate.id]: userWorkoutTemplate,
            },
          },
          {
            merge: true,
          }
        )
        .catch((err) => {
          suc = false;
          console.error(err);
        });
    }

    if (suc) {
      commit("addWorkoutTemplate", userWorkoutTemplate);
      return Promise.resolve(userWorkoutTemplate);
    }
    return Promise.reject("Somethign Went Wrong");
  },
  async updateWorkoutTemplate({ rootGetters }, payload: userWorkoutTemplate) {
    const myUID: string | null = rootGetters["userStore/getUserUID"];
    const userData: userData | null = rootGetters["userStore/getUserData"];

    if (!myUID) return Promise.reject("NOT SIGNED IN");
    if (!userData) return Promise.reject("USER HAS NO DATA");

    const workoutTemplates = userData.workoutTemplates;
    workoutTemplates[payload.id] = payload;

    let suc = true;

    const userRef = firebaseApp
      .firestore()
      .collection("users")
      .doc(myUID);

    await userRef
      .update({
        workoutTemplates,
      })
      .catch((err) => {
        console.error(err);
        suc = false;
      });

    if (suc) return Promise.resolve(payload);
    return Promise.reject("BAD");
  },
  async deleteWorkoutTemplate(
    { rootGetters, commit },
    templateIdToDelete: string
  ) {
    const myUID: string | null = rootGetters["userStore/getUserUID"];
    if (!myUID) return Promise.reject("NOT SIGNED IN");
    let suc = true;

    await firebaseApp
      .firestore()
      .collection("users")
      .doc(myUID)
      .set(
        {
          workoutTemplates: {
            [templateIdToDelete]: firebase.firestore.FieldValue.delete(),
          },
        },
        {
          merge: true,
        }
      )
      .catch((err) => {
        suc = false;
        console.error(err);
      });

    if (suc) {
      commit("deleteTemplate", templateIdToDelete);
      return Promise.resolve();
    }
    return Promise.reject("Somethign Went Wrong");
  },
  // payload of type past idx and future idx
  async changeOrderOfTemplateInFirestore(
    { rootGetters },
    payload: ChangeWorkoutTemplateOrder
  ) {
    const myUID: string | null = rootGetters["userStore/getUserUID"];
    if (!myUID) return Promise.reject("NOT SIGNED IN");

    let suc = true;

    const templateWithNewIdx: userWorkoutTemplate = payload.templateData;
    templateWithNewIdx.templateOrderIdx = payload.newTemplateOrderIdx;

    const userDocRef = firebaseApp
      .firestore()
      .collection("users")
      .doc(myUID);

    await userDocRef
      .set(
        {
          workoutTemplates: {
            [payload.templateData.id]: templateWithNewIdx,
          },
        },
        {
          merge: true,
        }
      )
      .catch((err) => {
        suc = false;
        console.log(err);
      });

    if (suc) return Promise.resolve();
    return Promise.reject();
  },
};

const templateStore = {
  namespace: true,
  state: new State(),
  getters: getters,
  mutations: mutations,
  actions: actions,
};

export default templateStore;
